
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/youtube/[id]",
      function () {
        return require("private-next-pages/youtube/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/youtube/[id]"])
      });
    }
  